export const searchUser = () => {
  // 検索ボタン
  const searchButton = document.getElementById( 'js-search-button' );

  // テーブル
  // const searchHide   = document.getElementById( 'js-hide' );
  // searchHide.style.display = 'none';

  // 登録ボタン
  const registButton  = document.querySelector( '.p-search-header__button .c-button-register' );

  // 編集ボタン
  const editButtons  = document.querySelectorAll( '.p-search-table__controller-item .edit' );

  // 削除ボタン
  const deleteButtons  = document.querySelectorAll( '.p-search-table__controller-item .delete' );

  // 担当ユーザーID
  const userButtons  = document.querySelectorAll( '.p-search-table__item .user' );

  // モーダルウィンドウ
  const modalRegist      = document.querySelector( '.js-modal-regist' );
  const modalRegistNext  = document.querySelector( '.js-modal-regist-next' );
  const modalEdit        = document.querySelector( '.js-modal-edit' );
  const modalEditNext    = document.querySelector( '.js-modal-edit-next' );
  const modalDelete      = document.querySelector( '.js-modal-delete' );
  const modalUser        = document.querySelector( '.js-modal-user' );

  if(searchButton){
    searchButton.addEventListener( 'click', () => {
      // searchHide.style.display = 'block';
    } );
  }

  if(registButton){
    registButton.addEventListener( 'click', () => {
      if(modalRegist){
        modalRegist.classList.add( 'is--show' );
      }
    } );
  }
    
  if(editButtons){
    editButtons.forEach( item => {
      item.addEventListener( 'click', () => {
        if(modalEdit){
          modalEdit.classList.add( 'is--show' );
        }
      } );
    } );
  }

  if(deleteButtons){
    deleteButtons.forEach( item => {
      item.addEventListener( 'click', () => {
        if(modalDelete){
          modalDelete.classList.add( 'is--show' );
        }
      } );
    } );
  }

  if(userButtons){
    userButtons.forEach( item => {
      item.addEventListener( 'click', () => {
        if(modalUser){
          modalUser.classList.add( 'is--show' );
        }
      } );
    } );
  }

  if(modalRegist && modalRegist.querySelector( '.p-modal__close' )){
    modalRegist.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
      modalRegist.classList.remove( 'is--show' );
    } );
  }
  if(modalRegistNext && modalRegistNext.querySelector( '.p-modal__close' )){
    modalRegistNext.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
      modalRegistNext.classList.remove( 'is--show' );
    } );
  }
  
  if(modalEdit && modalEdit.querySelector( '.p-modal__close' )){
    modalEdit.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
      modalEdit.classList.remove( 'is--show' );
    } );
  }

  if(modalEditNext && modalEditNext.querySelector( '.p-modal__close' )){
    modalEditNext.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
      modalEditNext.classList.remove( 'is--show' );
    } );
  }

  if(modalDelete && modalDelete.querySelector( '.p-modal__close' )){
    modalDelete.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
      modalDelete.classList.remove( 'is--show' );
    } );
  }

  if(modalUser && modalUser.querySelector( '.p-modal__close' )){
    modalUser.querySelector( '.p-modal__close' ).addEventListener( 'click', () => {
      modalUser.classList.remove( 'is--show' );
    } );
  }

  if(document.querySelector( '.js-regust-next' )){
    document.querySelector( '.js-regust-next' ).addEventListener( 'click', ( e ) => {
      if(modalRegist){
        modalRegist.classList.remove( 'is--show' );
      }
      if(modalRegistNext){
        modalRegistNext.classList.add( 'is--show' );
      }
      e.preventDefault();
    } );
  }

  if(document.querySelector( '.js-edit-next' )){
    document.querySelector( '.js-edit-next' ).addEventListener( 'click', ( e ) => {
      if(modalEdit){
        modalEdit.classList.remove( 'is--show' );
      }
      if(modalEditNext){
        modalEditNext.classList.add( 'is--show' );
      }
      e.preventDefault();
    } );
  }

  /**
   * 戻るボタン
   */
  const buttonPrevRegistInput = document.getElementById( 'js-modal-regist-input-prev' );
  if(buttonPrevRegistInput){
    buttonPrevRegistInput.addEventListener( 'click', () => {
      if(modalRegist){
        modalRegist.classList.remove( 'is--show' );
      }
    } );
  }

  const buttonPrevRegistInputNext = document.getElementById( 'js-modal-regist-input-next-prev' );
  if(buttonPrevRegistInputNext){
    buttonPrevRegistInputNext.addEventListener( 'click', () => {
      if(modalRegistNext){
        modalRegistNext.classList.remove( 'is--show' );
      }
      if(modalRegist){
        modalRegist.classList.add( 'is--show' );
      }
    } );
  }

  const buttonPrevEditInput = document.getElementById( 'js-modal-edit-input-prev' );
  if(buttonPrevEditInput){
    buttonPrevEditInput.addEventListener( 'click', () => {
      if(modalEdit){
        modalEdit.classList.remove( 'is--show' );
      }
    } );
  }

  const buttonPrevEditNextInput = document.getElementById( 'js-modal-edit-input-next-prev' );
  if(buttonPrevEditNextInput){
    buttonPrevEditNextInput.addEventListener( 'click', () => {
      if(modalEditNext){
        modalEditNext.classList.remove( 'is--show' );
      }
      if(modalEdit){
        modalEdit.classList.add( 'is--show' );
      }
    } );
  }

  const buttonPrevDelete = document.getElementById( 'js-modal-delete-prev' );
  if(buttonPrevDelete){
    buttonPrevDelete.addEventListener( 'click', () => {
      if(modalDelete){
        modalDelete.classList.remove( 'is--show' );
      }
    } );
  }

  /**
   * 個別設定
   */
  // ページ読み込み時
  $( 'input[data-switch-kobetsu]:checked' ).each( function () {
    const data = $( this ).attr( 'data-switch-kobetsu' );
    if ( data == 'On' ) {
      $( this ).parent().parent().next( '.p-special-select').removeClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).removeAttr('checked').prop("checked", false).change();
    } else {
      $( this ).parent().parent().next( '.p-special-select').addClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).attr('checked', true).prop('checked', true).change();
    }
  } );

  // イベント時
  $( 'input[data-switch-kobetsu]' ).on( 'change', function () {
    const data = $( this ).attr( 'data-switch-kobetsu' );
    if ( data == 'On' ) {
      $( this ).parent().parent().next( '.p-special-select').removeClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).removeAttr('checked').prop("checked", false).change();
    } else {
      $( this ).parent().parent().next( '.p-special-select').addClass( 'is--disabled' );
      $( this ).parent().parent().next( '.p-special-select').find( '.c-checkbox' ).attr('checked', true).prop('checked', true).change();
    }
  } );


  /**
   * 照会
   */
  $( 'input[data-switch-shokai]' ).parent().parent().next().css( 'display', 'none' );

  // ページ読み込み時
  $( 'input[data-switch-shokai]' ).each( function () {
    if ( $(this).prop('checked') == true ) {
      $( this ).addClass( 'is-on' );
      $( this ).parent().parent().next().css( 'display', 'block' );
    }
  } );

  // イベント時
  $( 'input[data-switch-shokai]' ).on( 'change', function () {
    if ( $(this).prop('checked') == true ) {
      $( this ).addClass( 'is-on' );
    } else {
      $( this ).removeClass( 'is-on' );
    }
    if ( $( this ).hasClass( 'is-on' ) ) {
      $( this ).parent().parent().next().css( 'display', 'block' );
    } else {
      $( this ).parent().parent().next().css( 'display', 'none' );
    }
  } );
}
